import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Button } from '../components/ui/button';
import { ArrowRight, Calendar, Clock, PlayCircle, Sparkles } from 'lucide-react';

const blogPosts = [
  {
    id: 0,
    category: 'Why Asha',
    title: 'Why Asha is the Only AI Dental Company That Truly Automates Your Full Office',
    excerpt: 'Stop stitching together single-point solutions. Discover the power of a complete AI workforce that drives revenue and efficiency.',
    image: 'https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=800&q=80',
    author: {
      name: 'Asha Team',
      avatar: 'https://i.pravatar.cc/150?img=20',
    },
    date: 'Dec 22, 2024',
    link: '/blog/why-asha',
  },
  {
    id: 1,
    category: 'Patient Experience',
    title: 'The Right Way to Think About Patient Experience with AI Receptionists',
    excerpt: 'Why comparing AI to human staff misses the point - and how the real value lies in capturing patients you would otherwise lose to voicemail.',
    image: 'https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=800&q=80',
    author: {
      name: 'Asha Team',
      avatar: 'https://i.pravatar.cc/150?img=20',
    },
    date: 'Dec 20, 2024',
    link: '/blog/patient-experience-ai-receptionist',
  },
  {
    id: 10,
    category: "Insurance & Revenue Cycle",
    title: "The Hidden Cost of Insurance Verification: Why Your Staff is Wasting 20+ Hours a Week on Hold",
    excerpt: "Picture this: It's 9:15 AM. Your insurance coordinator picks up the phone to verify benefits for tomorrow's patients. She dials Delta Dental.",
    image: "https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=800&q=80",
    author: {
      name: "Asha Team",
      avatar: "https://i.pravatar.cc/150?img=20"
    },
    date: "Jan 12, 2026",
    link: "/blog/insurance-verification-hidden-cost"
  },
  {
    id: 11,
    category: "Revenue Cycle Management",
    title: "Why 30% of Your Claims Get Denied (And How AI Claim Scrubbing Fixes It)",
    excerpt: "It was a routine crown prep. Documentation was solid. The procedure was necessary. Your biller submitted the claim, confident it would pay.",
    image: "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=800&q=80",
    author: {
      name: "Asha Team",
      avatar: "https://i.pravatar.cc/150?img=20"
    },
    date: "Jan 12, 2026",
    link: "/blog/claim-denials-ai-scrubbing"
  },
  {
    id: 12,
    category: "Revenue Cycle Management",
    title: "EOB Posting: The Most Tedious Task in Your Back Office (And Why It Doesn't Have to Be)",
    excerpt: "Every morning, your billing coordinator walks into the office and sees it: the stack.",
    image: "https://images.unsplash.com/photo-1629909615184-74f495363b67?w=800&q=80",
    author: {
      name: "Asha Team",
      avatar: "https://i.pravatar.cc/150?img=20"
    },
    date: "Jan 12, 2026",
    link: "/blog/eob-posting-automation"
  },
  {
    id: 13,
    category: "Schedule Optimization",
    title: "The $50,000 Problem: How Empty Chairs Are Killing Your Production",
    excerpt: "It's 1:45 PM. Your hygienist is finishing up with her current patient. The 2 PM slot? Empty. Mrs. Johnson cancelled this morning—something about he...",
    image: "https://images.unsplash.com/photo-1588776814546-1ffcf47267a5?w=800&q=80",
    author: {
      name: "Asha Team",
      avatar: "https://i.pravatar.cc/150?img=20"
    },
    date: "Jan 12, 2026",
    link: "/blog/empty-chairs-schedule-optimization"
  },
  {
    id: 14,
    category: "Patient Reactivation",
    title: "Your Hygiene Recall List is a Gold Mine (That You're Ignoring)",
    excerpt: "Somewhere in your practice management system, there's a report you probably haven't run in a while. It's your hygiene recall list—the patients who ...",
    image: "https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?w=800&q=80",
    author: {
      name: "Asha Team",
      avatar: "https://i.pravatar.cc/150?img=20"
    },
    date: "Jan 12, 2026",
    link: "/blog/hygiene-recall-gold-mine"
  },
  {
    id: 15,
    category: "Common Misconceptions",
    title: "\"AI Will Never Replace the Human Touch\" (And Other Myths Holding Your Practice Back)",
    excerpt: "\"We looked at AI for our front desk, but... I don't know. Our patients expect a human touch. They want to talk to a real person.\"",
    image: "https://images.unsplash.com/photo-1606811841689-23dfddce3e95?w=800&q=80",
    author: {
      name: "Asha Team",
      avatar: "https://i.pravatar.cc/150?img=20"
    },
    date: "Jan 12, 2026",
    link: "/blog/ai-myths-human-touch"
  },
  {
    id: 16,
    category: "Patient Communication",
    title: "The 24/7 Practice: Why After-Hours Calls Are Your Biggest Missed Opportunity",
    excerpt: "It's Tuesday night. Your practice closed at 5 PM. At 8:47 PM, your phone rings.",
    image: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=800&q=80",
    author: {
      name: "Asha Team",
      avatar: "https://i.pravatar.cc/150?img=20"
    },
    date: "Jan 12, 2026",
    link: "/blog/after-hours-calls-opportunity"
  },
  {
    id: 17,
    category: "Revenue Cycle Management",
    title: "Patient Billing Done Right: How to Collect More While Keeping Patients Happy",
    excerpt: "\"Mrs. Thompson, your insurance paid $340, so your remaining balance is $287.\"",
    image: "https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=800&q=80",
    author: {
      name: "Asha Team",
      avatar: "https://i.pravatar.cc/150?img=20"
    },
    date: "Jan 12, 2026",
    link: "/blog/patient-billing-done-right"
  },
  {
    id: 18,
    category: "General",
    title: "Your Aging A/R is Bleeding Money: The Case for AI-Powered Collections",
    excerpt: "Pull up your aging A/R report. Go ahead, we'll wait.",
    image: "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=800&q=80",
    author: {
      name: "Asha Team",
      avatar: "https://i.pravatar.cc/150?img=20"
    },
    date: "Jan 12, 2026",
    link: "/blog/ar-collections-aging-receivables"
  },
  {
    id: 19,
    category: "General",
    title: "Stop Accepting Claim Denials: How AI is Winning Appeals You Never Had Time to File",
    excerpt: "Last week, a claim came back denied. \"Not medically necessary,\" the EOB said. Your team looked at it, sighed, and moved on to the next task.",
    image: "https://images.unsplash.com/photo-1629909615184-74f495363b67?w=800&q=80",
    author: {
      name: "Asha Team",
      avatar: "https://i.pravatar.cc/150?img=20"
    },
    date: "Jan 12, 2026",
    link: "/blog/denial-management-appeals"
  },
  {
    "id": 20,
    "category": "General",
    "title": "The First 5 Minutes: Why Patient Intake Makes or Breaks Your Practice",
    "excerpt": "Picture this: A new patient walks into your practice for their first appointment. They're greeted warmly, handed a clipboard with 8 pages of forms,...",
    "image": "https://images.unsplash.com/photo-1588776814546-1ffcf47267a5?w=800&q=80",
    "author": {
      "name": "Asha Team",
      "avatar": "https://i.pravatar.cc/150?img=20"
    },
    "date": "Jan 12, 2026",
    "link": "/blog/patient-intake-first-impression"
  },
  {
    "id": 21,
    "category": "Schedule & Production Optimization",
    "title": "Case Acceptance: The Revenue You're Leaving on the Table",
    "excerpt": "Every day, patients leave your practice with treatment plans in hand. They nod along as you explain the procedure. They say they'll \"think about it...",
    "image": "https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?w=800&q=80",
    "author": {
      "name": "Asha Team",
      "avatar": "https://i.pravatar.cc/150?img=20"
    },
    "date": "Jan 12, 2026",
    "link": "/blog/case-acceptance-revenue-left-behind"
  },
  {
    "id": 22,
    "category": "Common Misconceptions",
    "title": "The \"We're Too Small for AI\" Myth (And Why It's Costing You)",
    "excerpt": "\"This all sounds great, but we're just a small practice. AI is for the big DSOs with hundreds of locations, right?\"",
    "image": "https://images.unsplash.com/photo-1606811841689-23dfddce3e95?w=800&q=80",
    "author": {
      "name": "Asha Team",
      "avatar": "https://i.pravatar.cc/150?img=20"
    },
    "date": "Jan 12, 2026",
    "link": "/blog/too-small-for-ai-myth"
  },
  {
    "id": 23,
    "category": "Common Misconceptions",
    "title": "Why \"Automated\" Insurance Verification Isn't Actually Automated",
    "excerpt": "\"Automated.\"",
    "image": "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=800&q=80",
    "author": {
      "name": "Asha Team",
      "avatar": "https://i.pravatar.cc/150?img=20"
    },
    "date": "Jan 12, 2026",
    "link": "/blog/automated-verification-isnt-automated"
  },
  {
    "id": 24,
    "category": "Practice Efficiency",
    "title": "The Communication Stack Tax: How Many Vendors Does It Take to Run Your Front Office?",
    "excerpt": "Here's a quick exercise: Count how many different software systems your front desk uses to communicate with patients.",
    "image": "https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=800&q=80",
    "author": {
      "name": "Asha Team",
      "avatar": "https://i.pravatar.cc/150?img=20"
    },
    "date": "Jan 12, 2026",
    "link": "/blog/communication-stack-tax"
  },
  {
    "id": 25,
    "category": "Practice Growth",
    "title": "The 5-Star Review Problem: Why Happy Patients Don't Leave Reviews (And How to Fix It)",
    "excerpt": "Your patients love you. They tell you so. They refer their friends. They've been coming for years.",
    "image": "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=800&q=80",
    "author": {
      "name": "Asha Team",
      "avatar": "https://i.pravatar.cc/150?img=20"
    },
    "date": "Jan 12, 2026",
    "link": "/blog/five-star-review-problem"
  },
  {
    id: 26,
    category: "Front Office",
    title: "Amy: Every Call Answered, Every Workflow Completed — 24/7",
    excerpt: "Your front desk can hold one phone at a time. Amy can hold every phone, in every language, around the clock — and she finishes the work, not just the conversation.",
    image: "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=800&q=80",
    author: { name: "Asha Team", avatar: "https://i.pravatar.cc/150?img=20" },
    date: "May 2, 2026",
    link: "/blog/amy-ai-receptionist-24x7",
  },
  {
    id: 27,
    category: "Practice Intelligence",
    title: "Stop Pulling Reports. Start Asking Questions.",
    excerpt: "How plain-language voice inside Asha replaces the digging, filtering, and report-rebuilding most practice management systems force you into.",
    image: "https://images.unsplash.com/photo-1551836022-d5d88e9218df?w=800&q=80",
    author: { name: "Asha Team", avatar: "https://i.pravatar.cc/150?img=20" },
    date: "May 2, 2026",
    link: "/blog/voice-ai-plain-language-insights",
  },
  {
    id: 28,
    category: "Revenue Cycle Management",
    title: "How Sarah Resolves a Complex Ortho Denial Before Your Team Logs In",
    excerpt: "Step-by-step problem solving — not template responses — turns denials from a multi-hour investigation into a draft appeal already on the desk.",
    image: "https://images.unsplash.com/photo-1554224155-1696413565d3?w=800&q=80",
    author: { name: "Asha Team", avatar: "https://i.pravatar.cc/150?img=20" },
    date: "May 2, 2026",
    link: "/blog/sarah-denial-auto-resolution",
  },
  {
    id: 29,
    category: "Patient Reactivation",
    title: "Stephanie: Hundreds of Hygiene Recall Conversations, All Running in Parallel",
    excerpt: "Continuous, two-way recall outreach across SMS and voice — adapting to each patient instead of blasting them.",
    image: "https://images.unsplash.com/photo-1606811971618-4486d14f3f99?w=800&q=80",
    author: { name: "Asha Team", avatar: "https://i.pravatar.cc/150?img=20" },
    date: "May 2, 2026",
    link: "/blog/stephanie-hygiene-recall-conversations",
  },
  {
    id: 30,
    category: "Schedule Optimization",
    title: "Every Open Chair, Filled in Parallel: Inside Leena, the AI Schedule Optimizer",
    excerpt: "Cancellations, no-shows, and same-day gaps stop being firefights. Leena reasons through every opening at once.",
    image: "https://images.unsplash.com/photo-1611073615452-4889cccdf106?w=800&q=80",
    author: { name: "Asha Team", avatar: "https://i.pravatar.cc/150?img=20" },
    date: "May 2, 2026",
    link: "/blog/leena-ai-schedule-optimizer",
  },
  {
    id: 31,
    category: "Schedule & Production Optimization",
    title: "Kim: Turning 'I'll Think About It' Into Booked Production",
    excerpt: "Open treatment plans don't fall through the cracks anymore — Kim follows up for weeks, adapting to each patient.",
    image: "https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=800&q=80",
    author: { name: "Asha Team", avatar: "https://i.pravatar.cc/150?img=20" },
    date: "May 2, 2026",
    link: "/blog/kim-case-acceptance-followups",
  },
  {
    id: 32,
    category: "Patient Experience",
    title: "Morgan: Every New Patient Arrives 100% Intaked — Without Anyone Lifting a Finger",
    excerpt: "Forms chased automatically, insurance cards OCR'd, structured fields written straight into the chart. The most-hated job at the front desk, gone.",
    image: "https://images.unsplash.com/photo-1582719471384-894fbb16e074?w=800&q=80",
    author: { name: "Asha Team", avatar: "https://i.pravatar.cc/150?img=20" },
    date: "May 2, 2026",
    link: "/blog/morgan-zero-touch-patient-intake",
  },
  {
    id: 33,
    category: "Insurance & Revenue Cycle",
    title: "Amanda Verifies Every Patient on Every Schedule — and Flags Denial Risk Days in Advance",
    excerpt: "A procedure-level breakdown for every patient, every day — written cleanly into your PMS before the chair is even sat in.",
    image: "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=800&q=80",
    author: { name: "Asha Team", avatar: "https://i.pravatar.cc/150?img=20" },
    date: "May 2, 2026",
    link: "/blog/amanda-procedure-level-verification",
  },
  {
    id: 34,
    category: "Practice Management",
    title: "Trisha: The AI Practice Manager That Triages Your Whole Weekend Before You Walk In",
    excerpt: "47 inbound items between Friday night and Sunday — already worked, already routed, already prioritized by 7:52 AM.",
    image: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=800&q=80",
    author: { name: "Asha Team", avatar: "https://i.pravatar.cc/150?img=20" },
    date: "May 2, 2026",
    link: "/blog/trisha-autonomous-morning-triage",
  },
  {
    id: 35,
    category: "Practice Efficiency",
    title: "Joseph: Every Inbound Fax Read, Routed, and Filed Before You Touch It",
    excerpt: "EOBs, lab results, referrals, specialist reports — classified, extracted, and matched to the right chart in the background.",
    image: "https://images.unsplash.com/photo-1568992687947-868a62a9f521?w=800&q=80",
    author: { name: "Asha Team", avatar: "https://i.pravatar.cc/150?img=20" },
    date: "May 2, 2026",
    link: "/blog/joseph-ai-fax-manager",
  },
  {
    id: 36,
    category: "Revenue Cycle Management",
    title: "Elena: Pre-Submission Claim Scrubbing That Stops Denials Before They Happen",
    excerpt: "Every claim, scrubbed against 15,000+ historical data points — staged for review the moment something looks wrong.",
    image: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=800&q=80",
    author: { name: "Asha Team", avatar: "https://i.pravatar.cc/150?img=20" },
    date: "May 2, 2026",
    link: "/blog/elena-pre-submission-claim-scrubbing",
  },
  {
    id: 37,
    category: "Revenue Cycle Management",
    title: "Alicia: Payment Posting at 10× Speed — and the Underpayments You'd Never Catch Manually",
    excerpt: "ERAs and paper EOBs, posted, reconciled, and verified against your contracted fee schedule in parallel — at 99.9% accuracy.",
    image: "https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?w=800&q=80",
    author: { name: "Asha Team", avatar: "https://i.pravatar.cc/150?img=20" },
    date: "May 2, 2026",
    link: "/blog/alicia-payment-posting-underpayments",
  },
  {
    id: 38,
    category: "Patient Billing",
    title: "Rachel: Tone-Matched Patient Collections That Actually Get Paid",
    excerpt: "Structured cadence, adaptive channel choice, contextual escalation — collections that don't feel like collections.",
    image: "https://images.unsplash.com/photo-1556745757-8d76bdb6984b?w=800&q=80",
    author: { name: "Asha Team", avatar: "https://i.pravatar.cc/150?img=20" },
    date: "May 2, 2026",
    link: "/blog/rachel-tone-matched-collections",
  },
  {
    id: 39,
    category: "Revenue Cycle Management",
    title: "Norah: Three-Way Bank Reconciliation, Continuous and to the Penny",
    excerpt: "Plaid bank deposits, your PMS, and the 835 ERA — matched by trace ID, continuously, with no end-of-week spreadsheet.",
    image: "https://images.unsplash.com/photo-1579621970795-87facc2f976d?w=800&q=80",
    author: { name: "Asha Team", avatar: "https://i.pravatar.cc/150?img=20" },
    date: "May 2, 2026",
    link: "/blog/norah-bank-reconciliation",
  },
  {
    id: 40,
    category: "Patient Communication",
    title: "One Timeline, Every Conversation: How a Unified Patient Story Replaces Your Comms Stack",
    excerpt: "SMS, email, voice — interleaved by timestamp, sentiment-tagged, and attached to the chart so the next teammate never starts from zero.",
    image: "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?w=800&q=80",
    author: { name: "Asha Team", avatar: "https://i.pravatar.cc/150?img=20" },
    date: "May 2, 2026",
    link: "/blog/unified-patient-communication-timeline",
  },
  {
    id: 41,
    category: "Practice Intelligence",
    title: "Calls as Structured Data: Why AI-Native Voice Beats a Library of Recordings",
    excerpt: "Every call — inbound or outbound, AI-handled or human — auto-classified, sentiment-tagged, and transformed into action items the moment it ends.",
    image: "https://images.unsplash.com/photo-1521119989659-a83eee488004?w=800&q=80",
    author: { name: "Asha Team", avatar: "https://i.pravatar.cc/150?img=20" },
    date: "May 2, 2026",
    link: "/blog/ai-native-call-intelligence",
  },
  {
    id: 42,
    category: "Patient Communication",
    title: "Marketing Lists That Update Themselves: Clinically Aware Patient Groups",
    excerpt: "Five auto-maintained groups, refreshed nightly from live chart data — with a built-in suppression layer that respects what just happened in the practice.",
    image: "https://images.unsplash.com/photo-1551836022-d5d88e9218df?w=800&q=80",
    author: { name: "Asha Team", avatar: "https://i.pravatar.cc/150?img=20" },
    date: "May 2, 2026",
    link: "/blog/clinically-aware-patient-groups",
  },
  {
    id: 43,
    category: "Practice Efficiency",
    title: "Internal Messaging That Lives Inside the Chart, Not Next to It",
    excerpt: "Slack-style channels, but every @mention is one click from the patient's full chart. The Slack-and-PMS dance is over.",
    image: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=800&q=80",
    author: { name: "Asha Team", avatar: "https://i.pravatar.cc/150?img=20" },
    date: "May 2, 2026",
    link: "/blog/internal-hub-chart-context",
  },
  {
    id: 44,
    category: "Patient Billing",
    title: "When the Card Reader Is the PMS: How In-Office Payments Become a Single Step",
    excerpt: "From three steps (terminal → manual entry → reconciliation) to one continuous workflow inside the chart, in real time.",
    image: "https://images.unsplash.com/photo-1556742400-b5b7c5121f6c?w=800&q=80",
    author: { name: "Asha Team", avatar: "https://i.pravatar.cc/150?img=20" },
    date: "May 2, 2026",
    link: "/blog/in-office-payments-unified-ledger",
  },
  {
    id: 45,
    category: "Patient Billing",
    title: "Text-to-Pay: How Instant Statements Replace 30 Days of Paper Mail",
    excerpt: "An itemized statement, a tone-matched message, a Stripe-hosted link. Most balances clear in under 60 seconds — without a single envelope.",
    image: "https://images.unsplash.com/photo-1563013544-824ae1b704d3?w=800&q=80",
    author: { name: "Asha Team", avatar: "https://i.pravatar.cc/150?img=20" },
    date: "May 2, 2026",
    link: "/blog/text-to-pay-instant-statements",
  },
  {
    id: 46,
    category: "Patient Experience",
    title: "Mobile-First Patient Forms: Why PDFs Are the #1 Reason Intake Breaks Down",
    excerpt: "Forms designed for the way patients actually use phones — and prepopulated from prior visits so no one fills out medical history twice.",
    image: "https://images.unsplash.com/photo-1512486130939-2c4f79935e4f?w=800&q=80",
    author: { name: "Asha Team", avatar: "https://i.pravatar.cc/150?img=20" },
    date: "May 2, 2026",
    link: "/blog/mobile-first-patient-forms",
  },
  {
    id: 47,
    category: "Video Demo",
    type: "video",
    title: "What is Asha AI, and why is it different?",
    excerpt: "A guided walkthrough of the world's first and only AI operating system for dental — 10+ softwares and 20+ AI products in one unified platform.",
    image: "https://cdn.loom.com/sessions/thumbnails/2f1798865b044075b51a096937c470c5-1df8b761200a1552-full-play.gif",
    author: { name: "Asha Team", avatar: "https://i.pravatar.cc/150?img=20" },
    date: "May 23, 2026",
    readTime: "6 min watch",
    link: "/blog/asha-ai-intro",
  },
  {
    id: 48,
    category: "Video Demo",
    type: "video",
    title: "Let me guess: your staff spent more than 15 hours this week posting EOBs",
    excerpt: "Watch Alisha post a batch — and catch the downcodes, alternative benefits, and fee mismatches your team misses when they're moving fast.",
    image: "https://cdn.loom.com/sessions/thumbnails/3ef872e7cfd7428aaaab0e573b956779-918b8d22aaff7114-full-play.gif",
    author: { name: "Asha Team", avatar: "https://i.pravatar.cc/150?img=20" },
    date: "May 23, 2026",
    readTime: "5 min watch",
    link: "/blog/alisha-eob-posting",
  },
  {
    id: 49,
    category: "Video Demo",
    type: "video",
    title: "Let me guess: your staff spent hours this week fighting denials",
    excerpt: "Watch Sarah work a complex denial end-to-end — reading benefits, clinical history, and prior claims, then drafting the appeal so your team reviews instead of writing from scratch.",
    image: "https://cdn.loom.com/sessions/thumbnails/4d43737293af43febc9820416a075f00-cc5bf9573264dd54-full-play.gif",
    author: { name: "Asha Team", avatar: "https://i.pravatar.cc/150?img=20" },
    date: "May 23, 2026",
    readTime: "5 min watch",
    link: "/blog/sarah-denial-management",
  }
];

const POSTS_PER_PAGE = 9;

const sortedPosts = [...blogPosts].sort(
  (a, b) => new Date(b.date) - new Date(a.date)
);

const BlogPage = () => {
  const [visibleCount, setVisibleCount] = useState(POSTS_PER_PAGE);
  const visiblePosts = sortedPosts.slice(0, visibleCount);
  const hasMore = visibleCount < sortedPosts.length;

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="pt-32 pb-20 px-6 relative overflow-hidden">
        {/* Gradient Background */}
        <div className="absolute inset-0 bg-gradient-to-b from-blue-50 via-indigo-50/50 to-white"></div>
        
        <div className="container mx-auto max-w-6xl text-center relative z-10">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-blue-50 text-blue-700 text-sm font-medium border border-blue-100 mb-6">
            <Sparkles className="w-4 h-4" />
            <span>Latest Insights</span>
          </div>
          
          <h1 className="text-5xl md:text-6xl font-bold mb-6 text-gray-900 tracking-tight">
            Our <span className="text-blue-600">Blog</span>
          </h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto leading-relaxed">
            Expert insights, tips, and strategies to transform your dental practice with AI-powered solutions.
          </p>
        </div>
      </section>

      {/* Blog Grid */}
      <section className="pb-24 px-6">
        <div className="container mx-auto max-w-7xl">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {visiblePosts.map((post) => {
              const ArticleWrapper = post.link ? Link : 'article';
              const wrapperProps = post.link ? { to: post.link } : {};
              
              return (
              <ArticleWrapper
                key={post.id}
                {...wrapperProps}
                className="group bg-white rounded-3xl overflow-hidden border border-gray-100 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300 cursor-pointer flex flex-col h-full"
              >
                {/* Image */}
                <div className="relative h-64 overflow-hidden">
                  <div className="absolute inset-0 bg-gray-200 animate-pulse" />
                  <img
                    src={post.image}
                    alt={post.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700 relative z-10"
                    loading="lazy"
                  />
                  <div className="absolute top-4 left-4 z-20">
                    <span className="inline-flex items-center gap-1.5 px-3 py-1 bg-white/90 backdrop-blur-md text-blue-700 text-xs font-bold rounded-full shadow-sm border border-white/50">
                      {post.type === 'video' && <PlayCircle className="w-3.5 h-3.5" />}
                      {post.category}
                    </span>
                  </div>
                  {post.type === 'video' && (
                    <div className="absolute inset-0 z-20 flex items-center justify-center pointer-events-none">
                      <div className="w-16 h-16 rounded-full bg-white/95 shadow-xl flex items-center justify-center group-hover:scale-110 transition-transform">
                        <PlayCircle className="w-9 h-9 text-blue-600" />
                      </div>
                    </div>
                  )}
                </div>

                {/* Content */}
                <div className="p-8 flex flex-col flex-grow">
                  <div className="flex items-center gap-3 text-sm text-gray-500 mb-4">
                    <div className="flex items-center gap-1">
                      <Calendar className="w-4 h-4" />
                      {post.date}
                    </div>
                    <span className="w-1 h-1 bg-gray-300 rounded-full" />
                    <div className="flex items-center gap-1">
                      <Clock className="w-4 h-4" />
                      {post.readTime || '5 min read'}
                    </div>
                  </div>

                  <h3 className="text-xl font-bold text-gray-900 group-hover:text-blue-600 transition-colors mb-3 line-clamp-2">
                    {post.title}
                  </h3>

                  <p className="text-gray-600 line-clamp-3 mb-6 flex-grow leading-relaxed">
                    {post.excerpt}
                  </p>

                  {/* Author */}
                  <div className="flex items-center justify-between pt-6 border-t border-gray-100 mt-auto">
                    <div className="flex items-center space-x-3">
<div className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center text-gray-700 text-xs font-bold border border-gray-100 flex-shrink-0">
                      A
                    </div>
                      <span className="text-sm font-medium text-gray-900">
                        {post.author.name}
                      </span>
                    </div>
                    <div className="w-8 h-8 rounded-full bg-blue-50 flex items-center justify-center group-hover:bg-blue-600 transition-colors">
                      <ArrowRight className="w-4 h-4 text-blue-600 group-hover:text-white transition-colors" />
                    </div>
                  </div>
                </div>
              </ArticleWrapper>
            );
            })}
          </div>

          {/* Load More Button */}
          {hasMore && (
            <div className="text-center mt-16">
              <Button
                type="button"
                onClick={() =>
                  setVisibleCount((count) =>
                    Math.min(count + POSTS_PER_PAGE, sortedPosts.length)
                  )
                }
                variant="outline"
                className="px-8 py-6 rounded-full text-base font-medium transition-all duration-300 hover:shadow-lg border-gray-200 text-gray-600 hover:text-blue-600 hover:border-blue-100 bg-white"
              >
                Load More Articles
              </Button>
            </div>
          )}
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 px-6">
        <div className="container mx-auto max-w-5xl">
          <div className="bg-gradient-to-br from-blue-600 to-indigo-700 rounded-[2.5rem] p-12 text-center relative overflow-hidden shadow-2xl">
            {/* Background Pattern */}
            <div className="absolute inset-0 opacity-10">
               <div className="absolute top-0 left-0 w-96 h-96 bg-white rounded-full mix-blend-overlay filter blur-3xl opacity-30 transform -translate-x-1/2 -translate-y-1/2"></div>
               <div className="absolute bottom-0 right-0 w-96 h-96 bg-white rounded-full mix-blend-overlay filter blur-3xl opacity-30 transform translate-x-1/2 translate-y-1/2"></div>
            </div>

            <div className="relative z-10 max-w-3xl mx-auto">
              <h2 className="text-3xl md:text-5xl font-bold text-white mb-6 leading-tight">
                Ready to transform your practice?
              </h2>
              <p className="text-xl text-blue-100 mb-10 leading-relaxed">
                Join dental practices using AI to capture more patients and streamline operations.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Button className="bg-white text-blue-600 hover:bg-blue-50 px-8 py-6 rounded-xl text-lg font-bold shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1">
                  Book a Demo
                </Button>
                <Button className="bg-blue-500/20 text-white hover:bg-blue-500/30 border border-white/20 px-8 py-6 rounded-xl text-lg font-bold backdrop-blur-sm transition-all duration-300">
                  View Pricing
                </Button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default BlogPage;